import React, { useState, useEffect, useRef } from "react";

import { useNotify, Title } from "react-admin";
import { API, graphqlOperation } from "aws-amplify";
import { formatDistanceToNow } from "date-fns";
import {
  TextField,
  Typography,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Backdrop,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getAudit } from "../../../graphql/queries";
import { AuditOutlinedIcon } from "../../../components/common/iconography";
import { HelpIconButton } from "../../../components/common/HelpButton";
import { AuditStatus } from "../../../utils/constants";
import { getNextItem, setNextItem } from "./Audit";
import OperatorsList from "./OperatorsList";
import LocationsMap from "./LocationsMap";
import { logError } from "../../../utils/appUtils";
import CrewCard from "../../../components/common/CrewCard";
import { getLocationViewName } from "../../../utils/locationUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
  },
  backdrop: {
    zIndex: 90001,
  },
  auditButtonCenter: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(4),
  },
  listHeader: {
    marginTop: theme.spacing(1.5),
    marginLeft: theme.spacing(2),
  },
  settings: {
    marginTop: theme.spacing(2),
  },
  inventoryCardAvatar: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    backgroundColor: theme.palette.secondary.main,
    width: theme.spacing(6),
    height: theme.spacing(6),
  },

  operators: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    flexWrap: "wrap",
  },
  item: {
    margin: theme.spacing(0.5),
  },
  help: {
    margin: theme.spacing(2),
    width: 600,
  },
  helpMobile: {
    margin: theme.spacing(2),
    width: "100%",
  },
}));

const ViewAudit = ({ audit, history, match, setViewState, returnToAudit }) => {
  const notify = useNotify();
  const classes = useStyles();
  const isComponentMounted = useRef(true);
  const [currentAudit, setCurrentAudit] = useState();
  const [locations, setLocations] = useState();
  const [, setCompletedLocations] = useState(0);
  const [index, setIndex] = useState(0);
  const [message, setMessage] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isComponentMounted) {
      getSelectedAudit();
      window.scrollTo(0, 0);
    }
  }, []);

  const getSelectedAudit = async () => {
    try {
      debugger;
      let inProgressAudit = audit;
      if (!audit) {
        const response = await API.graphql(
          graphqlOperation(getAudit, { id: match.params.id })
        );
        inProgressAudit = response.data.getAudit;
      }
      inProgressAudit = setCurrentAuditData(inProgressAudit);
      setLocations(inProgressAudit.locations.map((itm) => itm));
      setCurrentAudit(inProgressAudit);
      const idx = getNextItem(audit);
      setIndex(idx);
      debugger;
      computeCompleted(inProgressAudit);
      setMessage(
        `Created: ${formatDistanceToNow(new Date(audit.createdAt))} ago`
      );
    } catch (err) {
      logError("CreateAudit:getAudits", err, notify);
    }
  };

  const computeCompleted = (audit) => {
    let completedCount = 0;
    debugger;
    Object.keys(audit.processedLocations).forEach((key) => {
      if (
        audit.processedLocations[key].completed ===
        audit.processedLocations[key].total
      )
        completedCount++;
    });
    setCompletedLocations(completedCount);
  };

  const startAudit = () => {
    debugger;
    setNextItem(currentAudit, index);

    setLoading(false);
    setViewState("EDIT");
    history.push(`${match.url}`);
  };

  const setCurrentAuditData = (audit) => {
    debugger;
    if (typeof audit.processedItems === "string") {
      audit.processedItems = !audit.processedItems
        ? []
        : JSON.parse(audit.processedItems);
    }
    if (typeof audit.skippedItems === "string") {
      audit.skippedItems = !audit.skippedItems
        ? []
        : JSON.parse(audit.skippedItems);
    }
    if (typeof audit.processedLocations === "string") {
      audit.processedLocations = !audit.processedLocations
        ? {}
        : JSON.parse(audit.processedLocations);
    }
    return audit;
  };

  const cancel = () => {
    returnToAudit(false);
  };

  return (
    <>
      {loading ? (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : !currentAudit ? (
        <Typography variant="h5">No Audits found.</Typography>
      ) : (
        <>
          <Title title="Audit" />
          {
            <CrewCard
              title={
                currentAudit?.status === AuditStatus.NEW
                  ? "Start Audit"
                  : "Resume Audit"
              }
              icon={<AuditOutlinedIcon fontSize="large" />}
              action={
                <HelpIconButton>
                  <AuditHelp />
                </HelpIconButton>
              }
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {message && <Typography>{message}</Typography>}
                </Grid>
                <Grid item sm={12} xs={12}>
                  <LocationsMap
                    currentAudit={currentAudit}
                    locations={currentAudit.locations}
                  />
                </Grid>
                <Grid item sm={12}>
                  <OperatorsList
                    currentAudit={currentAudit}
                    locations={locations}
                    classes={classes}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="location-index"
                    select
                    margin="dense"
                    label="Location"
                    value={index}
                    variant="outlined"
                    style={{ minWidth: "50%" }}
                    onChange={(event) => setIndex(Number(event.target.value))}
                  >
                    {locations.map((option, idx) => (
                      <MenuItem key={option} value={idx}>
                        {getLocationViewName(option)}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item sm={12} xs={12}>
                  <TextField
                    name="note"
                    id="audit-note"
                    label="Notes"
                    multiline
                    minRows={3}
                    value={currentAudit.notes ? currentAudit.notes : ""}
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    disabled
                    onChange={(evt) =>
                      setCurrentAudit({
                        ...currentAudit,
                        notes: evt.target.value,
                      })
                    }
                  />
                </Grid>
              </Grid>
              <div className={classes.auditButtonCenter}>
                <Button size="large" color="primary" onClick={startAudit}>
                  Open
                </Button>
                <Button size="large" onClick={cancel}>
                  Cancel
                </Button>
              </div>
            </CrewCard>
          }
        </>
      )}
    </>
  );
};

const AuditHelp = () => (
  <>
    <p>
      The Audit Wizard will walk you through the Yard, guiding you from one
      Location & Inventory Item to the next. You can always skip an item, or
      pick another Location to work, if needed.
    </p>
    <p>
      As you visit each Location and count each Item, the system marks them as
      completed, and keeps track of all Items that were skipped. You can come
      back to skipped location by selecting it from dropdown in top navigation
      bar. If you skipped any items, the system will display a review screen at
      the end of an Audit, allowing you re re-visit skipped locations.
    </p>
    <p>
      Once all the inventory Items have been checked, the wizard will send the
      Audit results for.
    </p>
  </>
);

export default ViewAudit;
